import styled, { css } from 'styled-components';
import Colors from 'library/constants/colors';
import { ShadowElevation } from 'library/constants/styles-config';

export const Container = styled.div`
  padding: 14px 20px 24px;
  margin-bottom: 10px;
  background-color: ${Colors.shade08};
  border-radius: 8px;
`;

export const Slider = styled.div`
  position: relative;
  z-index: 2;
  width: 240px;
  height: 10px;
  
  input {
    cursor: pointer;
  }
`;

export const SliderRack = styled.div.attrs(({ edgeColor, color }) => ({
  style: {
    backgroundImage: `linear-gradient(90deg, ${edgeColor}, ${color})`,
  },
}))`
  position: absolute;
  z-index: 3;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  border-radius: 16px;
  cursor: pointer;
`;

const trackH = '10px';
const thumbD = '20px';

const track = css`
  box-sizing: border-box;
  border: none;
  height: 10px;
  background-image: linear-gradient(90deg, var(--edgeColor), var(--color));
  border-radius: 16px;
`;

const thumb = css`
  position: absolute;
  top: -1px;
  left: calc(var(--sx) - 25px);
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: ${Colors.shade08};
  box-shadow: ${ShadowElevation};
  outline: none!important;
`;

export const StyledInput = styled.input`
  &,
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
  }

  &:focus {
    outline: none;
  }

  &:focus::-webkit-slider-thumb {
    outline: -webkit-focus-ring-color auto 5px;
  }

  &:focus::-moz-range-thumb {
    outline: -webkit-focus-ring-color auto 5px;
  }

  &:focus::-ms-thumb {
    outline: -webkit-focus-ring-color auto 5px;
  }

  --range: calc(var(--max) - var(--min));
  --ratio: calc((var(--val) - var(--min)) / var(--range));
  --sx: calc(1 * ${thumbD} + var(--ratio) * (100% - ${thumbD}));

  margin: 0;
  padding: 0;
  height: ${thumbD};
  background: transparent;
  font: 1em/1 arial, sans-serif;

  &::-webkit-slider-runnable-track {
    ${track};
  }

  &::-moz-range-track {
    ${track};
  }

  &::-ms-track {
    ${track};
  }

  &::-webkit-slider-thumb {
    margin-top: calc(0.5 * (${trackH} - ${thumbD}));
    ${thumb};
  }

  &::-moz-range-thumb {
    ${thumb};
  }

  &::-ms-thumb {
    margin-top: 0;
    ${thumb};
  }

  &::-ms-tooltip {
    display: none;
  }

  &::-moz-focus-outer {
    border: 0;
  }
`;
